import { archiveUnarchiveAssignmentUnitEpicReducer } from "./epicsV2.js";
const getArchiveUnarchiveAssignmentUnitEpicReducer = () => archiveUnarchiveAssignmentUnitEpicReducer;
const rootEpic = archiveUnarchiveAssignmentUnitEpicReducer.epic;
export {
  rootEpic as default,
  getArchiveUnarchiveAssignmentUnitEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
